var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99945 12.2479C7.20695 12.2479 5.75195 10.7929 5.75195 9.00043C5.75195 7.20793 7.20695 5.75293 8.99945 5.75293C10.792 5.75293 12.247 7.20793 12.247 9.00043C12.247 10.7929 10.792 12.2479 8.99945 12.2479ZM8.99945 6.87793C7.82945 6.87793 6.87695 7.83043 6.87695 9.00043C6.87695 10.1704 7.82945 11.1229 8.99945 11.1229C10.1695 11.1229 11.122 10.1704 11.122 9.00043C11.122 7.83043 10.1695 6.87793 8.99945 6.87793Z",
    fill: "#1C1C1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.00055 15.7654C6.18055 15.7654 3.51805 14.1154 1.68805 11.2504C0.893047 10.0129 0.893047 7.99535 1.68805 6.75035C3.52555 3.88535 6.18805 2.23535 9.00055 2.23535C11.813 2.23535 14.4755 3.88535 16.3055 6.75035C17.1005 7.98785 17.1005 10.0054 16.3055 11.2504C14.4755 14.1154 11.813 15.7654 9.00055 15.7654ZM9.00055 3.36035C6.57805 3.36035 4.26055 4.81535 2.64055 7.35785C2.07805 8.23535 2.07805 9.76535 2.64055 10.6429C4.26055 13.1854 6.57805 14.6404 9.00055 14.6404C11.423 14.6404 13.7405 13.1854 15.3605 10.6429C15.923 9.76535 15.923 8.23535 15.3605 7.35785C13.7405 4.81535 11.423 3.36035 9.00055 3.36035Z",
    fill: "#1C1C1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlack);
export default __webpack_public_path__ + "static/media/eye-black.afe7bf8d1eb238ae3da88fd125dbea15.svg";
export { ForwardRef as ReactComponent };